import { ENTRIES_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import { axios } from '../services'

import { try_force_logoff } from './authActions'

import entriesTypes from '../constants/entriesTypes'

const reset_entry_errors = () => {
  return {
    type: entriesTypes.reset_errors
  }
}

// TOGGLE TITLE LENGTH COLUMN
const show_title_length_column = () => {
  return {
    type: entriesTypes.title_length.show
  }
}

const hide_title_length_column = () => {
  return {
    type: entriesTypes.title_length.hide
  }
}

// INDEX
const feed_entries_index_request = () => {
  return {
    type: entriesTypes.index.request
  }
}

const feed_entries_index_page_request = () => {
  return {
    type: entriesTypes.index.page_request
  }
}

const feed_entries_index_success = (response) => {
  return {
    type: entriesTypes.index.success,
    payload: response.data
  }
}

const feed_entries_index_page_success = (response) => {
  return {
    type: entriesTypes.index.page_success,
    payload: response.data
  }
}

const feed_entries_index_failure = (messages) => {
  return {
    type: entriesTypes.index.failure,
    payload: messages
  }
}

const feed_entries_sorted_request = () => {
  return {
    type: entriesTypes.index.sorted_request
  }
}

const feed_entries_sorted_success = (response) => {
  return {
    type: entriesTypes.index.sorted_success,
    payload: response.data
  }
}

const feed_entries_sorted_failure = (messages) => {
  return {
    type: entriesTypes.index.sorted_failure,
    payload: messages
  }
}

const feed_entries_set_filters = (filters) => {
  return {
    type: entriesTypes.set_filters,
    payload: filters
  }
}

const feed_entries_index = ( feed_id, page = 1, per_page = 50, sort='', order='', filters=[] ) => {
  return function (dispatch) {
    // REQUEST
    if ( page === 1 ) {
      if (sort === '' && order === '') {
        dispatch(feed_entries_index_request())
      } else {
        dispatch(feed_entries_sorted_request())
      }
      dispatch( feed_entries_set_filters(filters) )
    } else {
      dispatch(feed_entries_index_page_request())
    }

    axios.get(
      formatRoute(ENTRIES_ROUTES.index, {id: feed_id}),
      {
        params: {
      		page: page,
      		per_page: per_page,
          sort: sort,
          order: order,
          filters: filters
        }
      }
    ).then( response => {
      // success
      if (page === 1) {
        if (sort === '' && order === '') {
          dispatch( feed_entries_index_success(response) )
        } else {
          dispatch( feed_entries_sorted_success(response) )
        }
      } else {
        dispatch( feed_entries_index_page_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching feed."]
      }
      if (sort === '' && order === '') {
        dispatch( feed_entries_index_failure(errors))
      } else {
        dispatch( try_force_logoff(error.response.data) )
        dispatch( feed_entries_sorted_failure(errors))
      }
    })
  }
}

// UPDATE MULTIPLE ENTRIES
const feed_entries_um_request = () => {
  return {
    type: entriesTypes.um.request
  }
}

const feed_entries_um_success = (response) => {
  return {
    type: entriesTypes.um.success,
    payload: response.data
  }
}

const feed_entries_um_failure = (messages) => {
  return {
    type: entriesTypes.um.failure,
    payload: messages
  }
}

const feed_entries_um_set_icon = () => {
  return {
    type: entriesTypes.um.set_icon
  }
}


const feed_entries_um = ( feed_id, entry_ids, values ) => {
  return function (dispatch) {
    // REQUEST
    dispatch( feed_entries_um_request() )

    axios.patch(
      formatRoute(ENTRIES_ROUTES.um, {id: feed_id}),
      {
        ids: entry_ids,
        values: values
      }
    ).then( response => {
      // success
      dispatch( feed_entries_um_success(response) )
      dispatch( feed_entries_um_set_icon() )
    }).catch( error=> {
      // failure
      console.log(error)
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating entries."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( feed_entries_um_failure(errors) )
    })
  }
}

export {
  reset_entry_errors,
  show_title_length_column,
  hide_title_length_column,
  feed_entries_index,
  feed_entries_um
}

export * from './entries'



// WEBPACK FOOTER //
// ./src/js/actions/entriesActions.js